import { beneluxFallbackConfig } from "./departmentFields";
import type { DepartmentConfig } from "./types";

// Fallback config used when no API base is configured or the config request
// fails. Mirrors the original form's required fields and a form-first flow.
export function fallbackConfig(slug: string): DepartmentConfig {
  const key = slug.toLowerCase();
  if (key === "benelux") return beneluxFallbackConfig();
  return {
    slug: slug || "default",
    title: "New Quote Request",
    flow: ["form", "upload"],
    fields: {
      loadCountry: { required: false },
      loadPostal: { required: false },
      loadCity: { required: false },
      unloadCountry: { required: false },
      unloadPostal: { required: false },
      unloadCity: { required: false },
      pickupDate: { required: false },
      totalWeight: { required: true },
      goods: { required: false },
    },
    ui: {
      headerLabel: "New Quote Request",
      destinationEmail: "",
    },
  };
}
